document.addEventListener(
  "DOMContentLoaded",
  function () {
    console.log("Load: change-stock");

    // 在庫がない組み合わせの定義
    const unavailableCombinations = {
      // ▼▼▼ shops_stock_updatetoolで書き出された生地内容をコピペする ▼▼▼ //
tsdry: [],
tsldry: [{'size': '4L', 'color': 'ホワイト'}, {'size': '5L', 'color': 'ホワイト'},{'size': 'XXXL', 'color': 'ホワイト'}, {'size': 'XXXXL', 'color': 'ホワイト'}],
trpil: [{'size': 'XXL', 'color': 'ライトオリーブ'}, {'size': '110cm', 'color': 'ホワイト'}, {'size': '130cm', 'color': 'ブラック'}, {'size': '150cm', 'color': 'ブラック'}, {'size': '110cm', 'color': 'ミックスグレー'}, {'size': '130cm', 'color': 'ミックスグレー'}, {'size': '130cm', 'color': 'ナチュラル'}, {'size': '150cm', 'color': 'ナチュラル'}, {'size': '110cm', 'color': 'ネイビー'}, {'size': '130cm', 'color': 'ネイビー'}, {'size': '150cm', 'color': 'ネイビー'}, {'size': '110cm', 'color': 'チャコール'}, {'size': '130cm', 'color': 'チャコール'}, {'size': '150cm', 'color': 'チャコール'}, {'size': '110cm', 'color': 'オリーブ'}, {'size': '130cm', 'color': 'オリーブ'}, {'size': '150cm', 'color': 'オリーブ'}],
pppil: [{'size': '110cm', 'color': 'ナチュラル'}, {'size': '130cm', 'color': 'ネイビー'}, {'size': '110cm', 'color': 'チャコール'}, {'size': '130cm', 'color': 'チャコール'}, {'size': '150cm', 'color': 'チャコール'}, {'size': '110cm', 'color': 'オリーブ'}, {'size': '130cm', 'color': 'オリーブ'}, {'size': '150cm', 'color': 'オリーブ'}, {'size': '110cm', 'color': 'レッド'}, {'size': '130cm', 'color': 'レッド'}, {'size': '150cm', 'color': 'レッド'}],
zppil: [{'size': '150cm', 'color': 'ブラック'}, {'size': '130cm', 'color': 'ミックスグレー'}, {'size': '150cm', 'color': 'ミックスグレー'}, {'size': '130cm', 'color': 'ナチュラル'}, {'size': '130cm', 'color': 'ネイビー'}, {'size': '150cm', 'color': 'ネイビー'}, {'size': '110cm', 'color': 'チャコール'}, {'size': '130cm', 'color': 'チャコール'}, {'size': '150cm', 'color': 'チャコール'}, {'size': '110cm', 'color': 'オリーブ'}, {'size': '130cm', 'color': 'オリーブ'}, {'size': '150cm', 'color': 'オリーブ'}, {'size': '110cm', 'color': 'レッド'}, {'size': '130cm', 'color': 'レッド'}, {'size': '150cm', 'color': 'レッド'}],
swppil: [{'size': '130cm', 'color': 'ブラック'}, {'size': '130cm', 'color': 'ネイビー'}],
hptdry: [],
tsctn: [],
tslctn: [{'size': 'S', 'color': 'レッド'}, {'size': 'M', 'color': 'レッド'}, {'size': 'L', 'color': 'レッド'}, {'size': 'XL', 'color': 'レッド'}, {'size': 'XXL', 'color': 'レッド'}],
      // ▲▲▲ ここまで ▲▲▲ //
    };

    // 商品ごとのDOM要素と在庫なし組み合わせをマッピング
    const products = [
      {
        unavailableCombinations: unavailableCombinations.tsdry,
        sizeClass: "dd_1392203_554379",
        colorClass: "dd_1392207_554379",
      },
      {
        unavailableCombinations: unavailableCombinations.tsldry,
        sizeClass: "dd_1416693_563503",
        colorClass: "dd_1416695_563503",
      },
      {
        unavailableCombinations: unavailableCombinations.trpil,
        sizeClass: "dd_1416698_566177",
        colorClass: "dd_1416699_566177",
      },
      {
        unavailableCombinations: unavailableCombinations.pppil,
        sizeClass: "dd_1423682_566178",
        colorClass: "dd_1423684_566178",
      },
      {
        unavailableCombinations: unavailableCombinations.zppil,
        sizeClass: "dd_1423686_566180",
        colorClass: "dd_1423687_566180",
      },
      {
        unavailableCombinations: unavailableCombinations.tsctn,
        sizeClass: "dd_1423672_566165",
        colorClass: "dd_1423673_566165",
      },
      {
        unavailableCombinations: unavailableCombinations.tslctn,
        sizeClass: "dd_1423672_566165",
        colorClass: "dd_1423673_566165",
      },
      {
        unavailableCombinations: unavailableCombinations.hptdry,
        sizeClass: "dd_1606309_632508",
        colorClass: "dd_1606310_632508",
      },
    ];

    // 在庫なし商品の選択肢を更新する関数
    function updateStockStatus(product) {
      const sizeElement = document.getElementsByClassName(product.sizeClass)[0];
      const colorElement = document.getElementsByClassName(
        product.colorClass
      )[0];

      if (!sizeElement || !colorElement) return;

      // サイズまたは色が変更されたときに呼び出される関数
      const onOptionChange = () => {
        updateOptions(
          sizeElement,
          "size",
          colorElement,
          "color",
          product.unavailableCombinations
        );
        updateOptions(
          colorElement,
          "color",
          sizeElement,
          "size",
          product.unavailableCombinations
        );
      };

      // サイズと色の選択肢の変更イベントにリスナーを設定
      sizeElement.addEventListener("change", onOptionChange);
      colorElement.addEventListener("change", onOptionChange);

      // 最初の状態更新
      onOptionChange();
    }

    // 選択肢を更新する関数
    function updateOptions(
      element,
      attribute,
      otherElement,
      otherAttribute,
      unavailableCombinations
    ) {
      for (const option of element.options) {
        const isUnavailable = unavailableCombinations.some(
          (combination) =>
            combination[attribute] === option.value &&
            combination[otherAttribute] === otherElement.value
        );

        option.disabled = isUnavailable;

        // 「(在庫なし)」テキストを追加または削除
        const unavailableText = " (在庫なし)";
        if (isUnavailable && !option.innerText.includes(unavailableText)) {
          option.innerText += unavailableText;
        } else if (
          !isUnavailable &&
          option.innerText.includes(unavailableText)
        ) {
          option.innerText = option.innerText.replace(unavailableText, "");
        }
      }
    }

    // それぞれの製品に対して上記のロジックを適用
    products.forEach(updateStockStatus);
  },
  false
);